import moment from "moment";
import { RiLink, RiProductHuntFill, RiUser5Fill } from "react-icons/ri";
const LookupResultItemProduct = ({ item, active }) => {
  return (
    <>
      <div className="text-secondary  group-hover:text-white transition-all ">
        <RiProductHuntFill
          className={`${
            !item.isActive
              ? "text-red-500"
              : item.isDraft
              ? "text-zinc-400"
              : active
              ? "text-white"
              : "text-inherit"
          } `}
        />
      </div>
      <div className="w-full flex items-center justify-between">
        <div className={`${active && "text-white"} text-sm ml-2`}>
          {item.name} - {item.price}$
        </div>
        <div className="w-8 h-8">
          <img className="w-full h-full" src={item.images[0].url} alt="image" />
        </div>
      </div>
    </>
  );
};
const LookupResultItemCustomer = ({ item, active }) => {
  return (
    <>
      <div className="text-secondary  group-hover:text-white transition-all ">
        <RiUser5Fill className={`${active ? "text-white" : "text-inherit"} `} />
      </div>
      <div className="w-full flex items-center justify-between">
        <div className={`${active && "text-white"} text-sm ml-2`}>{item.email}</div>
        <div>
          <div className="text-sm text-white">{item.firstName + " " + item?.lastName}</div>
          <div className="text-xxs text-zinc-300">{moment(item.createdAt).format("LLL")}</div>
        </div>
      </div>
    </>
  );
};

const LookupResultItem = ({ item, active, routeHandler }) => {
  return (
    <div
      onClick={() => routeHandler(item)}
      className={`mb-1 p-2 hover:bg-secondary  hover:text-white flex items-center group cursor-pointer transition-all ${
        active ? "bg-secondary" : "bg-white"
      }`}
    >
      {item.brand ? (
        <LookupResultItemProduct item={item} active={active} />
      ) : item.email ? (
        <LookupResultItemCustomer item={item} active={active} />
      ) : (
        <>
          <div className="text-secondary  group-hover:text-white transition-all ">
            <RiLink className={`${active ? "text-white" : "text-inherit"} `} />
          </div>
          <div className={`${active && "text-white"} text-sm ml-2`}>{item.name}</div>
        </>
      )}
    </div>
  );
};

export default LookupResultItem;
